window.theme = window.theme || {}

theme.SourcepointCMP = class SourcepointCMP {
  constructor() {
    this.shopifyCustomerPrivacy = null
    this.sourcepointCMP = null
    this.isInitialized = false
    this.consentReady = false
    this.isSyncingConsent = false
    this.consentMapping = {
      marketing: ['purpose_3', 'purpose_4', 'purpose_5'],
      analytics: ['purpose_1', 'purpose_2'],
      preferences: ['purpose_7']
    }

    this.blockDataCollection()
    this.setupEventListeners()
  }

  setupEventListeners() {
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', () => {
      if (this.isDebugMode()) console.log('[SP] Shopify Customer Privacy API loaded')
      this.shopifyCustomerPrivacy = window.Shopify.customerPrivacy
      this.initializeIntegration()
    })

    document.addEventListener('sourcepointCMPReady', () => {
      if (this.isDebugMode()) console.log('[SP] Sourcepoint CMP ready')
      this.initializeIntegration()
    })

    document.addEventListener('sourcepointConsentReady', (event) => {
      if (this.isDebugMode()) console.log('[SP] Sourcepoint consent ready:', event.detail)
      this.consentReady = true
      this.syncConsentToShopify()

    })

    document.addEventListener('sourcepointMessageChoiceSelect', (event) => {
      if (this.isDebugMode()) console.log('[SP] Sourcepoint consent ready:', event.detail)
      console.log(event.detail);
      if (event.detail.choiceTypeId == 11) {
        this.setConsentShopify(true);
      }
    })

    document.addEventListener('visitorConsentCollected', (event) => {
      if (this.isDebugMode()) console.log('[SP] Shopify consent changed (ignoring to prevent circular updates):', event.detail)
      // Note: We don't sync back to Sourcepoint to prevent circular updates
      // Sourcepoint is the source of truth for consent
    })
  }

  isDebugMode() {
    return window.sourcepointConfig && window.sourcepointConfig.debug
  }

  initializeIntegration() {
    try {
      if (!this.shopifyCustomerPrivacy) {
        if (this.isDebugMode()) console.log('[SP] Shopify Customer Privacy API not ready yet')
        return
      }

      if (window.__tcfapi || window.__gpp) {
        if (window.__tcfapi) {
          this.sourcepointCMP = window.__tcfapi
          this.cmpType = 'tcf'
        } else if (window.__gpp) {
          this.sourcepointCMP = window.__gpp
          this.cmpType = 'gpp'
        }

        this.isInitialized = true
        if (this.isDebugMode()) console.log('[SP] Sourcepoint CMP integration initialized successfully')

        this.setupSourcepointEventListeners()
        this.syncConsentToShopify()
      } else {
        if (this.isDebugMode()) console.warn('[SP] Sourcepoint CMP not available yet, will retry when loaded')
        this.waitForSourcepointCMP()
      }
    } catch (error) {
      console.error('[SP] Failed to initialize Sourcepoint CMP integration:', error)
    }
  }

  waitForSourcepointCMP() {
    var observer = new MutationObserver(() => {
      if (window.__tcfapi || window.__gpp) {
        if (window.__tcfapi) {
          this.sourcepointCMP = window.__tcfapi
          this.cmpType = 'tcf'
        } else if (window.__gpp) {
          this.sourcepointCMP = window.__gpp
          this.cmpType = 'gpp'
        }

        this.isInitialized = true
        if (this.isDebugMode()) console.log('[SP] Sourcepoint CMP loaded, initializing integration')

        this.setupSourcepointEventListeners()
        this.syncConsentToShopify()
        observer.disconnect()
      }
    })

    observer.observe(document, {
      childList: true,
      subtree: true
    })

    setTimeout(() => {
      observer.disconnect()
      if (!this.isInitialized) {
        if (this.isDebugMode()) console.warn('[SP] Sourcepoint CMP not loaded within timeout period')
      }
    }, 15000)
  }

  setupSourcepointEventListeners() {
    if (!this.sourcepointCMP) return

    if (this.cmpType === 'tcf' || this.cmpType === 'gpp') {
      this.sourcepointCMP('addEventListener', 2, (tcData, success) => {
        if (success) {
          if (this.isDebugMode()) console.log('[SP] Sourcepoint consent changed:', tcData)
          this.syncConsentToShopify()
        }
      })
    }

  }

  setConsentShopify(consent) {
    if (consent) {
      const defaultConsent = {
        marketing: true,
        analytics: true,
        preferences: true
      };
      if(window.Shopify.customerPrivacy) {
        window.Shopify.customerPrivacy.setTrackingConsent(defaultConsent, (result) => {
          this.isSyncingConsent = false;
          if (result && result.error) {
            console.error('[SP] Failed to set default consent for non-regulated region:', result.error);
          } else {
            if (this.isDebugMode()) console.log('[SP] Successfully set default consent for non-regulated region:', defaultConsent);
            this.consentReady = true;
            this.allowDataCollection(defaultConsent);
          }
        });
      }
    }
  }

  syncConsentToShopify() {
    if (!this.sourcepointCMP || !this.shopifyCustomerPrivacy || this.isSyncingConsent) {
      return
    }

    this.isSyncingConsent = true
    if (this.cmpType === 'gpp') {
      this.sourcepointCMP('getTCData', 2, (tcData, success) => {
        if (success && tcData) {
          var consent = this.mapTCFToShopify(tcData)

          // Update Criteo consent specifically based on TCF data
          if (typeof criteo_q !== 'undefined' && window.criteoAccount) {
            console.log('[SP] Criteo OneTag consent updated:', tcData);
            const criteoConsent = this.mapTCFToCriteo(tcData);
            this.updateCriteoConsentDirect(criteoConsent, tcData);
          }

          this.shopifyCustomerPrivacy.setTrackingConsent(consent, (result) => {
            this.isSyncingConsent = false
            if (result && result.error) {
              console.error('[SP] Failed to set Shopify consent:', result.error)
            } else {
              if (this.isDebugMode()) console.log('[SP] Successfully synced consent to Shopify:', consent)
              // Allow data collection only after consent is synced
              this.allowDataCollection(consent)
            }
          })
        } else {
          this.isSyncingConsent = false
        }
      })
    } else if (window._sp_.usnat.getUserConsents) {
      window._sp_.usnat?.getUserConsents((consents, success) => {
        var consent = this.mapGPPToShopify(consents)
        this.shopifyCustomerPrivacy.setTrackingConsent(consent, (result) => {
          this.isSyncingConsent = false
          if (result && result.error) {
            console.error('[SP] Failed to set Shopify consent:', result.error)
          } else {
            if (this.isDebugMode()) console.log('[SP] Successfully synced consent to Shopify:', consent)
            // Allow data collection only after consent is synced
            this.allowDataCollection(consent)
          }
        })
      });
    }
    else {
      // If no CMP type detected, check if we're in a non-regulated region
      // and default to granting consent
      this.setDefaultConsentForNonRegulatedRegions()
    }
  }


  blockDataCollection() {
    // Block all analytics scripts until consent is ready
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'default', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'personalization_storage': 'denied',
        'functionality_storage': 'denied',
        'security_storage': 'granted'
      });
    }

    // Block Facebook Pixel if present
    if (typeof fbq !== 'undefined') {
      fbq('consent', 'revoke');
    }

    // Block Criteo OneTag if present
    if (typeof criteo_q !== 'undefined') {
      criteo_q.push(
        { event: "setAccount", account: window.criteoAccount || "" },
        { event: "setSiteType", type: "d" },
        { event: "setData", consent: "denied" }
      );
      if (this.isDebugMode()) console.log('[SP] Criteo OneTag consent denied until ready');
    }

    if (this.isDebugMode()) console.log('[SP] Data collection blocked until consent is ready');
  }

  allowDataCollection(consent) {
    if (!this.consentReady) {
      if (this.isDebugMode()) console.warn('[SP] Consent not ready yet, blocking data collection');
      return;
    }

    // Update Google Analytics consent
    if (typeof gtag !== 'undefined') {
      gtag('consent', 'update', {
        'ad_storage': consent.marketing ? 'granted' : 'denied',
        'analytics_storage': consent.analytics ? 'granted' : 'denied',
        'personalization_storage': consent.preferences ? 'granted' : 'denied'
      });
    }

    // Update Facebook Pixel consent
    if (typeof fbq !== 'undefined') {
      if (consent.marketing) {
        fbq('consent', 'grant');
      }
    }

    // Update Criteo OneTag consent
    this.updateCriteoConsent(consent);

    if (this.isDebugMode()) console.log('[SP] Data collection consent updated:', consent);
  }

  mapTCFToShopify(tcData) {
    // Check if GDPR applies - if not, default to granted consent for non-regulated regions
    if (!tcData.gdprApplies) {
      if (this.isDebugMode()) console.log('[SP] GDPR does not apply, granting default consent for non-regulated region');
      return {
        marketing: true,
        analytics: true,
        preferences: true
      };
    }

    var consent = {
      marketing: false,
      analytics: false,
      preferences: false
    };

    if (tcData.purpose && tcData.purpose.consents) {
      var purposeConsents = tcData.purpose.consents;

      consent.analytics = !!(purposeConsents['1'] || purposeConsents['2'] || purposeConsents['7'] || purposeConsents['8'] || purposeConsents['9']);
      consent.marketing = !!(purposeConsents['3'] || purposeConsents['4'] || purposeConsents['5'] || purposeConsents['6']);
      consent.preferences = !!(purposeConsents['5'] || purposeConsents['6']);
    }

    return consent;
  }

  mapGPPToShopify(consents) {
    let consent = true;
    consents.categories.forEach((category) => {
      if (category.consented == false) {
        consent = false;
      }
    });

    if (consent == true) {
      return {
        marketing: true,
        analytics: true,
        preferences: true
      };
    }
  }

  shouldShowBanner() {
    if (!this.shopifyCustomerPrivacy) {
      return false;
    }

    return this.shopifyCustomerPrivacy.shouldShowBanner();
  }

  getUserRegion() {
    if (!this.shopifyCustomerPrivacy) {
      return '';
    }

    return this.shopifyCustomerPrivacy.getRegion();
  }

  getConsentId() {
    if (!this.shopifyCustomerPrivacy) {
      return null;
    }

    return this.shopifyCustomerPrivacy.consentId();
  }

  updateCriteoConsent(consent) {
    if (typeof criteo_q === 'undefined') {
      if (this.isDebugMode()) console.log('[SP] Criteo OneTag not available');
      return;
    }

    // Map Shopify consent to Criteo OneTag format
    const criteoConsent = consent.marketing ? "granted" : "denied";

    try {
      criteo_q.push(
        { event: "setAccount", account: window.criteoAccount || "" },
        { event: "setSiteType", type: "d" },
        { event: "setData", consent: criteoConsent }
      );

      // If marketing consent is granted, enable Criteo tracking
      if (consent.marketing) {
        criteo_q.push({ event: "viewItem" });
      }

      if (this.isDebugMode()) console.log('[SP] Criteo OneTag consent updated:', criteoConsent);
    } catch (error) {
      console.error('[SP] Failed to update Criteo consent:', error);
    }
  }

  mapTCFToCriteo(tcData) {
    if (!tcData || !tcData.purpose || !tcData.purpose.consents) {
      return false;
    }

    const purposeConsents = tcData.purpose.consents;

    // Criteo requires Purpose 3 (personalized ads) and Purpose 4 (ad selection)
    // Also check for legitimate interest if consents are not available
    const hasMarketingConsent = purposeConsents['3'] || purposeConsents['4'];
    const hasLegitimateInterest = tcData.purpose.legitimateInterests &&
      (tcData.purpose.legitimateInterests['3'] || tcData.purpose.legitimateInterests['4']);

    // Check vendor consent for Criteo (vendor ID 91)
    const hasCriteoVendorConsent = tcData.vendor && tcData.vendor.consents && tcData.vendor.consents['91'];
    const hasCriteoLegitimateInterest = tcData.vendor && tcData.vendor.legitimateInterests && tcData.vendor.legitimateInterests['91'];

    return (hasMarketingConsent || hasLegitimateInterest) && (hasCriteoVendorConsent || hasCriteoLegitimateInterest);
  }

  updateCriteoConsentDirect(hasConsent, tcData) {
    if (typeof criteo_q === 'undefined') {
      if (this.isDebugMode()) console.log('[SP] Criteo OneTag not available for direct TCF update');
      return;
    }

    try {
      const criteoConsent = hasConsent ? "granted" : "denied";

      criteo_q.push(
        { event: "setAccount", account: window.criteoAccount },
        { event: "setSiteType", type: "d" },
        { event: "setData", consent: criteoConsent }
      );

      // If consent is granted and we have valid TCF data, track view
      if (hasConsent && tcData && tcData.gdprApplies) {
        criteo_q.push({ event: "viewItem" });
      }

      if (this.isDebugMode()) console.log('[SP] Criteo OneTag TCF consent updated:', criteoConsent, 'TCF Applied:', tcData?.gdprApplies);
    } catch (error) {
      console.error('[SP] Failed to update Criteo TCF consent:', error);
    }
  }

  setDefaultConsentForNonRegulatedRegions() {
    const userRegion = this.getUserRegion();
    const userCountry = userRegion.slice(0,2);
    // List of regions that don't require explicit consent (non-EU, non-California)
    const nonRegulatedCountries = ['AU', 'NZ', 'MX', 'BR', 'AR', 'CL', 'CO', 'JP', 'KR', 'SG', 'MY', 'TH', 'IN', 'ZA'];
    const regulatedRegions = [];

    if (nonRegulatedCountries.includes(userCountry) && !regulatedRegions.includes(userRegion)) {
      if (this.isDebugMode()) console.log('[SP] User in non-regulated region:', userRegion, 'granting default consent');

      const defaultConsent = {
        marketing: true,
        analytics: true,
        preferences: true
      };

      this.shopifyCustomerPrivacy.setTrackingConsent(defaultConsent, (result) => {
        this.isSyncingConsent = false;
        if (result && result.error) {
          console.error('[SP] Failed to set default consent for non-regulated region:', result.error);
        } else {
          if (this.isDebugMode()) console.log('[SP] Successfully set default consent for non-regulated region:', defaultConsent);
          this.consentReady = true;
          this.allowDataCollection(defaultConsent);
        }
      });
    } else {
      // In regulated region but no CMP loaded - keep blocking
      this.isSyncingConsent = false;
      if (this.isDebugMode()) console.log('[SP] In regulated region but no CMP, keeping consent blocked');
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (window.sourcepointConfig && window.sourcepointConfig.enabled) {
    window.sourcepointCMPIntegration = new theme.SourcepointCMP();
  }
});

window.SourcepointCMP = theme.SourcepointCMP;
